import { useSessionStorage } from "usehooks-ts";

export const useSelectedYear = () => {
  const [sessionStorageYearValue, setSessionStorageYearValue] =
    useSessionStorage("management-year", new Date().getFullYear());

  return { sessionStorageYearValue, setSessionStorageYearValue } as const;
};
